<script>
    import {
        CardLayout,
    } from "../../../../Components/Common/index.svelte";
    import {
        addIcon,
        deleteIcon
    } from "../../../../Utils/utilConstants.svelte";
    import MultiInsuranceDetails from "./encounter/MultiInsuranceDetails.svelte";
    import MultiPatientDetails from "./encounter/MultiPatientDetails.svelte";
    import MultiProcedureDetails from "./encounter/MultiProcedureDetails.svelte";
    import ShowMore from "../../../../Components/Common/ShowMore.svelte";
    import MultiPatientContactDetails from "./encounter/MultiPatientContactDetails.svelte";
    import { getGenderType, getInsuranceType, getPatientAge } from "../../../../Utils/utilFunctions.svelte";

    export let patientEncounters;
    export let commonDetails;
    export let onAddEncounter;
    export let onRemoveEncounter;
    export let overrideValidation;

    // New refs passed as props
    export let patientDetailsRefs = [];
    export let insuranceDetailsRefs = [];
    export let patientContactDetailsRefs = [];

    const getPatientItemTitle = (item, index) => {
        if(!item.expanded){
            //show expanded details
             //check if dob is filled
            var age = "";
            var gender = ""
            var insurance = ""
            if(item.patientDetails.birthDate && item.patientDetails.sex >= 0 && item.patientDetails.insuranceType >= 0){
                age += `${getPatientAge(item.patientDetails.birthDate)} years`;
                gender += `, ${getGenderType(item.patientDetails.sex)}`;
                var text = getInsuranceType(item.patientDetails.insuranceType, "shortTitle");
                insurance += `, ${text}`;
            }

            var details = `${age}${gender}${insurance}`

            return `Patient #${index + 1} ${item.patientDetails.firstName ?? ''} ${item.patientDetails.lastName ?? ''}${details.length == 0 ? '' : ` (${details})`}`;
        } else {
            //not expanded, show normal
            if (!item.patientDetails.firstName && !item.patientDetails.lastName){
                return `Patient #${index + 1}`;
            }

            return `Patient #${index + 1} ${item.patientDetails.firstName ?? ''} ${item.patientDetails.lastName ?? ''}`;
        }
       
    };
  
</script>

<CardLayout title="Multiple encounters list" enableCollapse={false} >
    <div class="flex flex-1 flex-col gap-2 p-4">
        {#if patientEncounters.length === 0}
            <div>Please add at least one patient</div>
        {:else}
            {#each patientEncounters as item, index}
                <CardLayout
                    headerClass="card-layout-empty-header"
                    cardClass="multi-encounter-details-card"
                    title={getPatientItemTitle(item, index)}
                    enableCollapse={true}
                    defaultExpanded={item.expanded}
                    onExpandCollapse={(val) => {
                        item.expanded = val;
                    }}
                    btnOptions={[{
                        iconName: "deleteIcon",
                        hasTooltip: false,
                        iFont: deleteIcon,
                        btnText: "Remove",
                        iconFunction: () => onRemoveEncounter(index),
                    }]}
                >
                    <MultiPatientDetails
                        index={index}
                        bind:this={patientDetailsRefs[index]}
                        bind:commonDetails={commonDetails}
                        bind:patientDetails={item.patientDetails}
                        bind:patientContactDetails={item.patientContactDetails}
                        bind:insuranceDetails={item.insuranceDetails}
                        bind:workerCompensation={item.workerCompensation}
                        bind:workerCompensationObj={item.workerCompensationObj}
                        bind:trafficAuthority={item.trafficAuthority}
                        bind:trafficAuthorityObj={item.trafficAuthorityObj}
                        bind:publicInPrivateObj={item.publicInPrivateObj}
                        bind:thirdPartyPayerObj={item.thirdPartyPayerObj}
                        bind:insuranceDetailsRef={insuranceDetailsRefs[index]}
                        isFromCreate={true}
                    />

                    <MultiProcedureDetails
                        bind:patientEncounterDetails={item.patientEncounterDetails}
                        {overrideValidation}
                        bind:patientDetails={item.patientDetails}
                    />

                    <MultiInsuranceDetails
                        index={index}
                        bind:this={insuranceDetailsRefs[index]}
                        bind:patientDetails={item.patientDetails}
                        bind:patientEncounterDetails={item.patientEncounterDetails}
                        bind:insuranceDetails={item.insuranceDetails}
                        bind:workerCompensation={item.workerCompensation}
                        bind:workerCompensationObj={item.workerCompensationObj}
                        bind:trafficAuthority={item.trafficAuthority}
                        bind:trafficAuthorityObj={item.trafficAuthorityObj}
                        bind:publicInPrivateObj={item.publicInPrivateObj}
                        bind:thirdPartyPayerObj={item.thirdPartyPayerObj}
                        bind:defenceObj={item.defenceObj}
                        bind:selectedHospital={commonDetails.selectedHospital}
                        bind:selectedDoctorProvider={commonDetails.selectedDoctorProvider}
                        {overrideValidation}
                        commonDetails={commonDetails}
                    />

                    <div class={`flex flex-row gap-2 pl-4 ${item.showContactPersonDetails ? '' : 'pb-4'}`}>
                        <ShowMore
                            bind:showMore={item.showContactPersonDetails}
                            details={`${item.showContactPersonDetails ? "Hide" : "Show"} more details`}
                        />
                    </div>

                    {#if item.showContactPersonDetails}
                        <div class="p-4">
                            <MultiPatientContactDetails
                                index={index}
                                bind:this={patientContactDetailsRefs[index]}
                                bind:patientContactDetails={item.patientContactDetails}
                                bind:patientEncounterDetails={item.patientEncounterDetails}
                            />
                        </div>
                    {/if}
                </CardLayout>
            {/each}
        {/if}

        <!-- svelte-ignore a11y-click-events-have-key-events -->
        <!-- svelte-ignore a11y-no-static-element-interactions -->
        <div on:click={onAddEncounter}
            class="flex-1 flex items-center justify-center rounded-md p-2 border border-dashed border-gray-400 cursor-pointer hover:bg-secondary hover:text-white">
            Add patient
        </div>
    </div>
</CardLayout>
